import { IBaseFilters } from '../../../common/filter/FilterManager'
import { ReportOutcome } from './types'

/**
 * Состояние фильтров отчёта по выплатам мэтчинга (CPAYMENT-1760).
 *
 * Кассы здесь нет намеренно: у выплат мэтчинга `cashbox_id` не заполняется, бэкенд фильтр по кассе
 * игнорирует, поэтому селект давал бы всегда пустую выдачу.
 *
 * Ось периода живёт в `dateRange.mode` — отдельного селекта под неё не заводим, режимы задаёт
 * сам `dateRange` через `filterProps.modes`.
 */
export interface IMatchingPayoutFilters extends IBaseFilters {
  /** Токены мерчантов **депозита** — владельцев чанков, а не владельцев выплаты. */
  merchantTokenList: string[]
  paymentAdapterIdList: string[]
  /** Типы методов (`SBP P2P RUB`, …) — бэкенд ждёт тип, а не id. */
  paymentMethods: string[]
  /** Укрупнённый исход выплаты; пусто и оба значения дают одну и ту же выборку. */
  outcomes: ReportOutcome[]
}

export const MATCHING_PAYOUT_DATE_MODE = {
  created: 'created',
  completed: 'completed',
} as const

export const MATCHING_PAYOUT_DATE_MODES = [
  { value: MATCHING_PAYOUT_DATE_MODE.created, label: 'По дате создания выплаты' },
  { value: MATCHING_PAYOUT_DATE_MODE.completed, label: 'По дате закрытия выплаты' },
]
